import { CALL_API } from 'redux-api-middleware'
import { constructEndpoint, constructQueries, sorted } from '../utils/helpers'

export const ROLES_REQUEST = 'roles/REQUEST'
export const ROLES_RECEIVE = 'roles/RECEIVE'
export const ROLES_FAILURE = 'roles/FAILURE'
export const ROLES_POST_DIALOG_REQUEST = 'roles/POST_DIALOG_REQUEST'
export const ROLES_POST_DIALOG_RECEIVE = 'roles/POST_DIALOG_RECEIVE'
export const ROLES_POST_DIALOG_FAILURE = 'roles/POST_DIALOG_FAILURE'
export const ROLES_PUT_DIALOG_REQUEST = 'roles/PUT_DIALOG_REQUEST'
export const ROLES_PUT_DIALOG_RECEIVE = 'roles/PUT_DIALOG_RECEIVE'
export const ROLES_PUT_DIALOG_FAILURE = 'roles/PUT_DIALOG_FAILURE'
export const ROLES_DELETE_DIALOG_REQUEST = 'roles/DELETE_DIALOG_REQUEST'
export const ROLES_DELETE_DIALOG_RECEIVE = 'roles/DELETE_DIALOG_RECEIVE'
export const ROLES_DELETE_DIALOG_FAILURE = 'roles/DELETE_DIALOG_FAILURE'

const initialState = {
  roles: [],
  totalCount: 0
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ROLES_DELETE_DIALOG_RECEIVE:
      const newRoles = state.roles.filter(role => {
        return role.id !== action.meta.id
      })
      return {
        ...state,
        roles: sorted(newRoles)
      }
    case ROLES_RECEIVE:
      return {
        ...state,
        totalCount: action.payload.data.totalCount,
        roles: sorted(action.payload.data.items)
      }
    case ROLES_POST_DIALOG_RECEIVE:
      const updatedRoles = [...state.roles]
      updatedRoles.unshift({...action.payload.data.item})
      return {
        ...state,
        roles: sorted(updatedRoles)
      }
    case ROLES_PUT_DIALOG_RECEIVE:
      const updatedRole = [...state.roles].map(role => {
        if (role.id === action.payload.data.item.id) {
          role = action.payload.data.item
        }
        return role
      })
      return {
        ...state,
        roles: sorted(updatedRole)
      }
    default:
      return state
  }
}

export function fetchRoles(isRefreshRequired) {
  return (dispatch, getState) => {
    const queries = constructQueries(getState(), 'role')
    return dispatch({
      [CALL_API]: {
        endpoint: constructEndpoint('/api/v1/authz/roles', queries.join(''), isLocal()),
        method: 'GET',
        credentials: 'include',
        types: [
          ROLES_REQUEST,
          {
            type: ROLES_RECEIVE,
            meta: { isRefreshRequired : isRefreshRequired ? true : false }
          },
          {
            type: ROLES_FAILURE,
            meta: { isRefreshRequired : isRefreshRequired ? true : false }
          }]
      }
    })
  }
}

export function postRole(formValues) {
  return (dispatch, getState) => {
    const { csrfToken } = getState().csrf
    return dispatch({
      [CALL_API]: {
        endpoint: isLocal() ? 'http://localhost:8080/api/v1/authz/roles' :
          '/api/v1/authz/roles',
        method: 'POST',
        body: JSON.stringify(formValues),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token' : csrfToken
        },
        types: [ROLES_POST_DIALOG_REQUEST, ROLES_POST_DIALOG_RECEIVE, ROLES_POST_DIALOG_FAILURE]
      }
    })
  }
}

export function putRole(formValues) {
  return (dispatch, getState) => {
    const { csrfToken } = getState().csrf
    return dispatch({
      [CALL_API]: {
        endpoint: isLocal() ? `http://localhost:8080/api/v1/authz/roles/${formValues.id}` :
          `/api/v1/authz/roles/${formValues.id}`,
        method: 'PUT',
        body: JSON.stringify(formValues),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token' : csrfToken
        },
        types: [ROLES_PUT_DIALOG_REQUEST, ROLES_PUT_DIALOG_RECEIVE, ROLES_PUT_DIALOG_FAILURE]
      }
    })
  }
}

export function removeRole(role) {
  const { id } = role
  return (dispatch, getState) => {
    const { csrfToken } = getState().csrf
    return dispatch({
      [CALL_API]: {
        endpoint: isLocal() ? `http://localhost:8080/api/v1/authz/roles/${id}` :
          `/api/v1/authz/roles/${id}`,
        method: 'DELETE',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token' : csrfToken
        },
        types: [ROLES_DELETE_DIALOG_REQUEST,
          {
            type: ROLES_DELETE_DIALOG_RECEIVE,
            meta: { id }
          },
          ROLES_DELETE_DIALOG_FAILURE]
      }
    })
  }
}

function isLocal() {
  return process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test'
}

export default reducer
